import { type Data } from "./_types";

export const DEFAULT_TITLE = "InResi | Find your perfect apartment";

export function pageTitle(data: Data | undefined): string {
  const propertyName = data?.property?.data?.name;
  return propertyName ? `${propertyName} | InResi` : DEFAULT_TITLE;
}
